<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>{{ title }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-text-field
          label="*商品コード"
          v-model="item.cd"
          :error-messages="validation_errors.cd"
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
      >
        <v-select
          label="*広告商品カテゴリ"
          :items=$store.getters.adsProductCategories
          item-text="name"
          item-value="id"
          v-model="item.adsproductcategory_id"
          :error-messages="validation_errors.adsproductcategory_id"
        ></v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*広告商品名"
          v-model="item.name"
          :error-messages="validation_errors.name"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
      <v-col
        cols="12"
        md="2"
        sm="6"
        v-if="!$attrs.isCreate"
      >
      <v-btn
        v-if="item.id"
        class="default"
        :to="{ name: 'AdsProductDetail', params: {id: item.id}}"
      >商品明細</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      item: {},
      validation_errors: {},
    };
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "広告商品新規登録";
    } else {
      this.title = "広告商品編集";
      this.getItem();
    }
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/adsproducts/${this.$route.params.id}/`
        )
        this.item = response.data;
      } catch(error) {
        console.log(error);
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'AdsProductList'}).catch(()=>{});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/adsproducts/`,
          this.item
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push({'name': 'EditAdsProduct', 'params': {id: this.item.id}});
      } catch(error) {
        console.log(error.response.data);
        console.log('sippai');
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/adsproducts/${this.$route.params.id}/`,
          this.item
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
      } catch(error) {
        console.log(error.response.data);
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
  }
}
</script>